import script from "./FormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormField.vue?vue&type=script&setup=true&lang=ts"

import "./FormField.vue?vue&type=style&index=0&id=bb98404e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb98404e"]])

export default __exports__